export default "__VITE_ASSET__DNCYsAja__"